<template>
  <label class="ui-checkbox" :class="{ 'is-disabled': disabled }">
    <input
      class="ui-checkbox__input"
      type="checkbox"
      :checked="isChecked"
      :disabled="disabled"
      @change="onChange"
    />

    <span class="ui-checkbox__box" aria-hidden="true">
      <Transition name="ui-tick">
        <span v-if="isChecked" class="ui-tick-mark">
          <Check :size="16" :stroke-width="3" />
        </span>
      </Transition>
    </span>

    <span v-if="$slots.default" class="ui-checkbox__label"><slot /></span>
  </label>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { Check } from "lucide-vue-next";

const props = withDefaults(
  defineProps<{
    modelValue?: unknown;
    value?: unknown;
    uncheckedValue?: unknown;
    disabled?: boolean;
  }>(),
  {
    modelValue: () => false,
    value: () => true,
    uncheckedValue: () => false,
    disabled: false,
  },
);

const emit = defineEmits<{
  "update:modelValue": [value: unknown];
}>();

const isChecked = computed(() => props.modelValue === props.value);

const onChange = (event: Event): void => {
  emit(
    "update:modelValue",
    (event.target as HTMLInputElement).checked ? props.value : props.uncheckedValue,
  );
};
</script>
